// context/StepContext.js
import { createContext, useContext, useState } from 'react';

const StepContext = createContext(null);

export function StepProvider({ children }) {
  const [step, setStep] = useState(0);

  const goToStep = (targetStep) => {
    setStep(targetStep);
  };

  return (
    <StepContext.Provider value={{ step, setStep, goToStep }}>
      {children}
    </StepContext.Provider>
  );
}

export function useStep() {
  const context = useContext(StepContext);
  if (!context) {
    throw new Error('useStep must be used within a StepProvider');
  }
  return context;
}
